import { TherapistAction } from '../../../src/redux/actions/constant';

export const reassignTherapistTaskAction = (payload: any) => {
    return {
        type: TherapistAction.THERAPIST_REARRANGE_TASK_REQUEST,
        payload,
    };
};

